import { Routes } from '@angular/router';
import { IndustriesContainerComponent } from './industries-container/industries-container.component';
import { HealthcareComponent } from './healthcare/healthcare.component';
import { FinanceComponent } from './finance/finance.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { ECommerceComponent } from './e-commerce/e-commerce.component';
import { EducationElearningComponent } from './education-elearning/education-elearning.component';
import { MediaEntertainmentComponent } from './media-entertainment/media-entertainment.component';
import { HiTechComponent } from './hi-tech/hi-tech.component';

export const INDUSTRIES_ROUTES: Routes = [
    {path: '', component: IndustriesContainerComponent,children: [
        {path:'healthtech', component: HealthcareComponent},
        {path:'fintech', component: FinanceComponent},
        {path:'insurtech', component: InsuranceComponent},
        {path:'ecommerce', component: ECommerceComponent},
        {path:'edtech', component: EducationElearningComponent},
        {path:'media-entertainment', component: MediaEntertainmentComponent},
        {path:'hitech', component: HiTechComponent},
    ]}
]